import { render } from "./print-gaji-tetap-unit-OK.vue?vue&type=template&id=4c286b1c&scoped=true"
import script from "./print-gaji-tetap-unit-OK.vue?vue&type=script&lang=js"
export * from "./print-gaji-tetap-unit-OK.vue?vue&type=script&lang=js"

import "./print-gaji-tetap-unit-OK.vue?vue&type=style&index=0&id=4c286b1c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c286b1c"]])

export default __exports__